import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import Typography from '../Typography';
import SearchIcon from '../Icons/SearchIcon';

const LocationTimePicker = ({ onClick, municipality, filters, tFilter }) => {
  return (
    <LocationTimeFilter onClick={onClick}>
      <SearchIcon fill={theme.colors.defaultSubtle} height={16} width={16} />
      <Typography as="p" $variant="body-3-medium" color={theme.colors.defaultWeak}>
        {tFilter('locationFilters.header.mobileTitle')}
      </Typography>
      <Typography as="p" $variant="body-3-medium" color={theme.colors.defaultWeak}>
        {municipality ? municipality : tFilter('LocationFilters.location.loading')}
      </Typography>
      <Typography as="p" $variant="body-3-medium" color={theme.colors.defaultWeak}>
        ·
      </Typography>
      <Typography as="p" $variant="body-3-medium" color={theme.colors.defaultWeak}>
        {filters.timeFilter ? tFilter(`timeFilters.time.${filters.timeFilter}`) : tFilter('timeFilters.time.flexible')}
      </Typography>
    </LocationTimeFilter>
  );
};

export default LocationTimePicker;

const LocationTimeFilter = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  border-radius: ${({ theme }) => theme.sizing.xs};
  box-shadow: 0 2px 4px 0 ${({ theme }) => `${theme.fill.inverseMain}14`};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xxs};
  height: ${({ theme }) => theme.sizing.lg};
  padding: 0 ${({ theme }) => theme.sizing.xs};
  position: relative;
  width: 100%;
`;